module.exports = __webpack_public_path__ + "static/media/team-3.f979f90e.jpg";